
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.938 4C7.824 4 6.41 5.273 5.75 6.594 5.09 7.914 5 9.274 5 10h2c0-.484.125-1.625.563-2.5C8 6.625 8.543 6 9.938 6c1.214 0 1.976.457 2.687 1.469.71 1.011 1.262 2.613 1.625 4.656.547 3.063.71 7.047.75 11.406v.313c.012 1.355 0 2.75 0 4.156h2c0-1.512.012-3.008 0-4.469.043-4.023.215-7.91.75-11 .367-2.113.902-3.836 1.625-4.937C20.098 6.492 20.879 6 22.063 6c1.394 0 1.937.625 2.375 1.5.437.875.562 2.016.562 2.5h2c0-.727-.09-2.086-.75-3.406C25.59 5.274 24.176 4 22.062 4c-1.843 0-3.367 1.012-4.343 2.5-.797 1.21-1.309 2.734-1.688 4.469-.386-1.84-.918-3.43-1.781-4.656C13.258 4.902 11.75 4 9.937 4z"}})])
          )
        }
      }
    